// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Window {
  AndroidBridge: {
    share: (url: string) => void;
  };
}

(() => {
  const shareLink = document.querySelectorAll(".js-share-link");

  if (!!shareLink.length) {
    const url = window.location.href;

    shareLink.forEach((element) => {
      element.addEventListener("click", async (event) => {
        event.preventDefault();

        if (window.AndroidBridge) {
          window.AndroidBridge.share(url);
          return;
        }

        if (
          !navigator.canShare ||
          !navigator.share ||
          !navigator.canShare({ url })
        )
          return;

        await navigator.share({
          url,
        });
      });
    });
  }
})();
